module.exports = __webpack_public_path__ + "img/sld_scb_11_t1_green.382e12f3.svg";